require('./scheduledTransfersContentTableRow.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @ components
const ScheduledTransfersOptionsButtons = require('components/transfers/scheduled/scheduledTransfersOptionsButtons/scheduledTransfersOptionsButtons');
const WebappRender = require('components/conditionalRender/webappRender')
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { LabelDate } = require('commonsComponents/labelDate');

// @ commons
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKButton } = require('commonsComponents/OKButton');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @ utilities
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

// @ constants
const { HYPHEN } = require('constants/index');
const INVALID_PRODUCT_NUMBER = '696';
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');

// @ actions
const scheduledTransfersDetailsActions = require('actions/scheduledTransfersDetails');


class ScheduledTransfersContentTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.buildEditButton = this.buildEditButton.bind(this);
        this.buildTrashButton = this.buildTrashButton.bind(this);
        this.handleRowClick = this.handleRowClick.bind(this);
        this.handleRowButtons = this.handleRowButtons.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
    }

    handleRowClick() {
        const { id, onRowClick } = this.props;
        onRowClick(id);
    }

    handleRedirect(url) {
        this.props.history.push(url);
    }

    handleRowButtons(url) {
        const { getScheduledTransfersDetails, immTransaction } = this.props;
        const accountId = immTransaction.get('accountId');
        const scheduledTransfersId = immTransaction.get('id');

        if (!!immTransaction.get('details')) {
            this.handleRedirect(url);
        } else {
            getScheduledTransfersDetails(accountId, scheduledTransfersId, this.handleRedirect, url);
        }
    }

    buildEditButton(accountId, scheduledId, disabled, isFetchingDetails) {
        const editScheduledTransferLink = `/myprofile/transfers/scheduled/${accountId}/${scheduledId}/edit`;
        const tooltipText = disabled ? <FormattedText value="transfersScheduled-invalidProductMessage" /> : <FormattedText value="editScheduledTransfer-modify" />;
        let modifyButton = (
            <div className="scheduled-transfers-table-row__actions__button-container" >
                <OKButton
                    disabled={disabled}
                    loaderColor="dark"
                    loaderSize="small"
                    loading={isFetchingDetails}
                    modifier="task"
                    onClick={() => this.handleRowButtons(editScheduledTransferLink)}
                    size="small"
                >
                    <i className="icon-s-editar" />
                </OKButton>
            </div>
        );
        return <OKTooltip content={tooltipText} target={modifyButton} />
    }

    buildTrashButton(accountId, scheduledId, disabled, isFetchingDetails) {
        const removeScheduledTransferLink = `/myprofile/transfers/scheduled/${accountId}/remove/${scheduledId}`;
        const tooltipText = disabled ? <FormattedText value="transfersScheduled-invalidProductMessage" /> : <FormattedText value="editScheduledTransfer-cancel" />;
        const trashButton = (
            <div className="scheduled-transfers-table-row__actions__button-container" >
                <OKButton
                    disabled={disabled}
                    loaderColor="dark"
                    loaderSize="small"
                    loading={isFetchingDetails}
                    modifier="task"
                    onClick={() => this.handleRowButtons(removeScheduledTransferLink)}
                    size="small"
                >
                    <i className="icon-eliminar" />
                </OKButton>
            </div>
        );
        return <OKTooltip content={tooltipText} target={trashButton} />
    }

    render() {
        const { id, immTransaction, immScreen, isExpanded } = this.props;
        const expandIconClass = classNames({ 'icon-accordion-abrir': !isExpanded, 'icon-accordion-cerrar': isExpanded });
        const plainAmountObject = getPlainAmountObject(immTransaction.get('amount'));
        const language = getLanguage();
        const accountId = immTransaction.get('accountId');
        const scheduledId = immTransaction.get('id');
        const editDisabled = (immTransaction.getIn(['extra', 'product']) === INVALID_PRODUCT_NUMBER);
        const isFetchingDetails = immTransaction.getIn(['fetchingDetails']);

        let periodicityCell = HYPHEN;
        let tableRow;

        if (immTransaction.get('isDeferred')) {
            periodicityCell = formatText('transfersScheduled-deferredPeriodicity');
        } else if (immTransaction.get('periodicityText')) {
            periodicityCell = formatText(`transfersScheduled-${immTransaction.get('periodicityText')}` );
        }

        let endDate = (
            <LabelDate
                date={immTransaction.get('endDate')}
                language={language}
                today={LABEL_DATE_TODAY}
                yesterday={LABEL_DATE_YESTERDAY}
            />
        );

        if (immTransaction.get('endDate').year() === 9999) {
            endDate = (<FormattedText value="transfersScheduled-endDateUndefined" />);
        }

        if (immScreen.get('isMobile')) {
            const mobileDetailNoMargin = classNames(
                "scheduled-transfers-table-row__detail-mobile",
                "scheduled-transfers-table-row__detail-mobile--no-margin"
            );

            tableRow = (
                <OKTableRow id={id} isExpanded={isExpanded}>
                    <OKTableCell className="scheduled-transfers-table-row__expand-cell-mobile">
                        <button
                            className="last-movements-table-row__expand-button"
                            onClick={this.handleRowClick}
                        >
                            <i className={expandIconClass} />
                        </button>
                    </OKTableCell>
                    <OKTableCell>
                        <p className="scheduled-transfers-table-row__detail-mobile">
                            {immTransaction.get('concept') || HYPHEN}
                        </p>
                        <p className={mobileDetailNoMargin}>
                            {periodicityCell}
                        </p>
                        <p className={mobileDetailNoMargin}>
                            <OneLineSymbolAmount
                                amountObject={plainAmountObject}
                                language={language}
                                amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                            />
                        </p>
                    </OKTableCell>
                </OKTableRow>
            );
        } else {
            tableRow = (
                <OKTableRow id={id} isExpanded={isExpanded}>
                    <OKTableCell>
                        <button
                            className="last-movements-table-row__expand-button"
                            onClick={this.handleRowClick}
                        >
                            <i className={expandIconClass} />
                        </button>
                    </OKTableCell>
                    <OKTableCell className="scheduled-transfers-table-row__start-date">
                        <LabelDate
                            date={immTransaction.get('startDate')}
                            language={language}
                            today={LABEL_DATE_TODAY}
                            yesterday={LABEL_DATE_YESTERDAY}
                        />
                    </OKTableCell>
                    <OKTableCell className="scheduled-transfers-table-row__end-date">
                        {endDate}
                    </OKTableCell>
                    <OKTableCell className="scheduled-transfers-table-row__periodicity">
                        {periodicityCell}
                    </OKTableCell>
                    <OKTableCell className="scheduled-transfers-table-row__concept-cell">
                        <p className="scheduled-transfers-table-row__concept">
                            {immTransaction.get('concept') || HYPHEN}
                        </p>
                    </OKTableCell>
                    <OKTableCell className="scheduled-transfers-table-row__amount">
                        <OneLineSymbolAmount
                            amountObject={plainAmountObject}
                            language={language}
                            amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                    </OKTableCell>
                    <OKTableCell className="scheduled-transfers-table-row__actions">

                        <WebappRender>
                            <ScheduledTransfersOptionsButtons immTransaction={immTransaction} />
                        </WebappRender>

                        <ContactCenterRender>
                            {this.buildEditButton(accountId, scheduledId, editDisabled, isFetchingDetails)}
                            {this.buildTrashButton(accountId, scheduledId, editDisabled, isFetchingDetails)}
                        </ContactCenterRender>

                    </OKTableCell>
                </OKTableRow>
            );
        }

        return tableRow;
    }
}

ScheduledTransfersContentTableRow.propTypes = {
    history: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    immTransaction: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    onRowClick: PropTypes.func,
    isExpanded: PropTypes.bool,
    getScheduledTransfersDetails: PropTypes.func.isRequired
};

ScheduledTransfersContentTableRow.defaultProps = {
    onRowClick: function() {}
};

module.exports = connect(
    state => ({
        immScreen: state.screen,
    }),
    {
        getScheduledTransfersDetails: scheduledTransfersDetailsActions.getScheduledTransfersDetails,
    })(withRouter(ScheduledTransfersContentTableRow));
